import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@talentmesh/ui/components/dialog';
import { useWatch } from 'react-hook-form';
import { getEmailTemplateHtml } from '../../utils/getEmailTemplateHtml';
import { useEditEmailTemplateContext } from './useEditEmailTemplate';
import EmailTemplateViewer from '@/Components/EmailTemplate/EmailTemplateViewer';
import { useCompanyContext } from '@/Context/CompanyContext';
import { useUserContext } from '@/Context/UserContext';
import { EmailTemplateType } from '@/Models/Configuration';
import UIStrings from '@/Utils/UIStrings';

export interface PreviewEmailDialogProps {
    open: boolean;
    dialogTitle: string;
    bodyHtml: string;
    thankYouMessage: string;
    templateType: EmailTemplateType;
    onClose?: () => void;
}

function PreviewEmailDialog({
    dialogTitle,
    bodyHtml,
    thankYouMessage,
    templateType,
    open,
    onClose,
}: PreviewEmailDialogProps) {
    const { control } = useEditEmailTemplateContext();
    const title = useWatch({ control, name: 'title' });
    const regards = useWatch({ control, name: 'regards' });
    const { user } = useUserContext();
    const { currentCompanyProfile } = useCompanyContext();

    return (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose?.()}>
            <DialogContent className="max-w-xl border-none shadow-none">
                <DialogHeader className="flex flex-row items-center justify-between">
                    <DialogTitle>{dialogTitle}</DialogTitle>
                </DialogHeader>
                <div className="border-border mt-4 rounded-xl border p-4">
                    <EmailTemplateViewer
                        className="max-h-126 border-0"
                        htmlTemplate={getEmailTemplateHtml(
                            title,
                            thankYouMessage,
                            bodyHtml,
                            regards,
                            UIStrings.ApplicantsNamePlaceholder,
                            `${user?.firstName} ${user?.lastName}`,
                            currentCompanyProfile.companyName,
                            undefined,
                            templateType !== EmailTemplateType.RejectTemplate,
                        )}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default PreviewEmailDialog;
